type Props = {
   variant?: "zen" | "normal";
   size?: "sm" | "md" | "lg";
   className?: string;
   fullScreen?: boolean;
};
export const Loading = ({
   variant = "zen",
   size = "md",
   className = "",
   fullScreen = false
}: Props) => {
   const zenSizeStyles = {
      sm: "h-4 w-4 border-t-2 border-b-2",
      md: "h-9 w-9 border-t-2 border-b-2",
      lg: "h-16 w-16 border-t-2 border-b-2"
   };
   const defaultVariantSizeStyles = {
      sm: "h-4 w-4 border-t-[1px]",
      md: "h-6 w-6 border-t-2",
      lg: "h-16 w-16 border-t-4"
   };

   const containerClass = fullScreen
      ? "fixed inset-0 flex items-center justify-center"
      : "flex items-center justify-center";

   const spinnerBaseStyle = () => {
      switch (variant) {
         case "normal":
            return defaultVariantSizeStyles[size];
         case "zen":
         default:
            return zenSizeStyles[size];
      }
   };

   return (
      <div className={containerClass}>
         <div
            className={`animate-spin rounded-full ${spinnerBaseStyle()} border-primary ${className}`}
         />
      </div>
   );
};
